// This can be used to list all group invoices in a table,
// or a specific invoice for drill down features.
//
// Example showing all group invoices:
//            <invoice-data
//              group_id = 625
//            ></invoice-data>
//
// Example showing a specific invoice data:
//          <invoice-data
//            billing_invoice_id = ${this.billing_invoice_id}
//            previous_selector_id = "invoice_viewer"
//          ></invoice-data>
export class InvoiceData extends HTMLElement {
  constructor() {
    super();
  }

  async init_record_data_table() {
    const url = `/admin/billing_invoices/${this.billing_invoice_id}/show_data`
    const res = await fetch(url);
    const data = await res.json();
    // console.log(JSON.stringify(data.data))
    if (data.data === null) return

    $('#invoice_record_data #invoice_id').text( data.data.billing_invoice_id )
    $('#invoice_record_data #billing_run_id').text( data.data.billing_run_id )
    $('#invoice_record_data #invoice_date').text( moment(data.data.invoice_date).format("MMM DD, YYYY") )
    $('#invoice_record_data #billing_group_name').text( data.data.billing_group_name )
    $('#invoice_record_data #stripe_invoice_pdf_url').attr( "href", data.data.stripe_invoice_pdf_url )
    $('#invoice_record_data #stripe_invoice_number').text( data.data.stripe_invoice_number )
    $('#invoice_record_data #stripe_payment_url').attr('href', data.data.stripe_payment_url )

    const clazz = (data.data.stripe_invoice_paid === 0) ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok' ;
    $('#invoice_record_data #stripe_invoice_paid').addClass(clazz)

    const title = (data.data.stripe_invoice_paid === 0) ? 'Invoice has not been paid' : 'Invoice has been paid' ;
    $('#invoice_record_data #stripe_invoice_paid').attr('title', title)


    const unpaid_invoice_count = (data.data.stripe_invoice_paid === 1) ? 1 : 0
    this.dispatchUnpaidInvoicesEvent(unpaid_invoice_count)
  }

  async init_invoices_table() {
      const this_class = this
      this.table = $(this.querySelector('#group_invoices')).DataTable({
      "ajax": `/admin/groups/${this.group_id}/invoices`,
      "columns": [
        {
          "render": function( data, type, row ) {
            return moment(row.invoice_date).format("MMM DD, YYYY")
          },
          "class": "text-center"
        },
        {
          "render": function( data, type, row ) {
            if (row.stripe_paid_at) {
              return moment(row.stripe_paid_at * 1000).format("MMM DD, YYYY")
            }
            else {
              return ''
            }
          },
          "class": "text-center"
        },
        {
          "render": function ( data, type, row ) {
            return row.stripe_invoice_number
          },
          "className" : "text-center"
        },
        {
          "render": function ( data, type, row ) {
            return `<a 
                  target='_blank'
                  href=${row.stripe_payment_url}
                  title='Open payment portal in new tab'
                  id='stripe_payment_url' 
                  class='text-center'>
                  Payment Portal</a>`
          },
          "className" : "text-center"
        },
        {
          "render": function ( data, type, row ) {
            const clazz = (row.stripe_invoice_paid === 0) ? 'glyphiconno glyphicon-remove' : 'glyphiconyes glyphicon-ok' ;
            return "<i class='invoice_status " + clazz + "'></i>";
          },
          "className" : "text-center"
        },
        {
          "render": function ( data, type, row ) {
            return row.stripe_paid_with;
          },
          "className" : "text-center"
        },
        {
          "render": function ( data, type, row ) {
            return `<a 
                  href=${row.stripe_invoice_pdf_url}
                  title='Click to download invoice PDF'
                  class='text-center'>
                    <span class='text-center'>
                    <i class="fa fa-download" aria-hidden="true"></i>
                    </span>
                  </a>`
          },
          "className" : "text-center"
        },
        {
          "render": function ( data, type, row ) {
            return `<a 
                data_invoice_id=${row.billing_invoice_id}
                title='Click to view invoice'
                class="view-invoice">View</a>`
          },
          "className" : "dt-center group-user-action"
        },

      ],
      order: [[ 0, "asc" ]],
      initComplete: function () {
        // count the number of unpaid invoices and send an event. Listeners can then act upon this.
        let unpaid_invoice_count = 0
        this.api().data().each(function(data){
          unpaid_invoice_count = (data.stripe_invoice_paid === 0) ? unpaid_invoice_count + 1 : unpaid_invoice_count
        })

        this_class.dispatchUnpaidInvoicesEvent(unpaid_invoice_count)
      },
    });  
  }
  
  dispatchUnpaidInvoicesEvent(count) {

    let msg = `There are ${count} unpaid invoices`
    if (count === 1) {
      msg = "There is one unpaid invoice."
    }
    
    this.dispatchEvent(new CustomEvent('unpaid_invoice_count', 
      {bubbles: true, detail: {count: count, message: msg}}))
  }
  
  group_invoices_html() {
    return `
          <table id="group_invoices" class="table datatable" style="width:100%">
            <thead>
                <tr>
                  <th>Billing Date</th>
                  <th>Paid Date</th>
                  <th>Invoice Id</th>
                  <th>Payment URL</th>
                  <th>Payment Status</th>
                  <th>Paid By</th>
                  <th>Receipt</th>
                  <th>Actions</th>
                </tr>
            </thead>
            <tbody>
            </tbody>
          </table>    
    `
  }
  
  async init_charges_table() {
    const TOTAL_PRICE_COLUMN_INDEX = 8;

    $('#invoice_charges').DataTable({
      ajax: `/admin/billing_invoices/${this.billing_invoice_id}/charges`,
      columns: [

        { 
          data : "rate_schedule_name", "visible" : true, "searchable":true, "orderable":true,
          class: "text-center",
          render: function ( data, type, row ) {
            return `
            ${row.rate_schedule_name}
            `;
          }
        },
        {
          data: "description",
          class: "",
        },
        {
          data: "billed_group_name",
          class: "",
        },
        {
          data: "location_name",
          class: "",
        },
        { 
          data : "quantity", "visible" : true, "searchable":true, "orderable":true,
          class: "text-right",
          render: function ( data, type, row ) {
            return numeral( row.quantity ).format('0,000');
          }
        },   


        {
          data: "tier_low_value",
          class: "text-right",
        },      
        {
          data: "tier_high_value",
          class: "text-right",
        },      

        { 
          data : "price", "visible" : true, "searchable":true, "orderable":true,
          class: "text-right",
          render: function ( data, type, row ) {
            return numeral( row.price ).format('$0,0.00');
          }
        },  

        { 
          data : "total", "visible" : true, "searchable":true, "orderable":true,
          class: "text-right",
          render: function ( data, type, row ) {
            return numeral( row.total ).format('$0,0.00');
          }
        },   
  

        { 
          data : "period_start_date", "visible" : true, "searchable":true, "orderable":true,
          class: "text-center",
          render: function ( data, type, row ) {
            return moment(row.period_start_date).format("MM/DD/YYYY");
          }
        },
        { 
          data : "period_end_date", "visible" : true, "searchable":true, "orderable":true,
          class: "text-center",
          render: function ( data, type, row ) {
            return moment(row.period_end_date).format("MM/DD/YYYY");
          }
        }, 
      ],
      
      'destroy': true,
      'pageLength':100,
      'stateSave': true,
      'order': ['1', 'asc'],
      'initComplete': function () {},
      "footerCallback": function ( row, data, start, end, display ) {
          var api = this.api();

          // Remove the formatting to get integer data for summation
          var intVal = function ( i ) {
            return typeof i === 'string' ?
              i.replace(/[\$,]/g, '')*1 :
              typeof i === 'number' ?
                  i : 0;
          };

          // Total over all pages
          this.total = api
              .column( TOTAL_PRICE_COLUMN_INDEX )
              .data()
              .reduce( function (a, b) {
                  return intVal(a) + intVal(b);
              }, 0 );
  
          // Total over this page
          this.pageTotal = api
              .column( TOTAL_PRICE_COLUMN_INDEX, { page: 'current'} )
              .data()
              .reduce( function (a, b) {
                  return intVal(a) + intVal(b);
              }, 0 );
  
          // Update footer
          this.pageTotal = numeral( this.pageTotal ).format('$0,0.00')
          this.total = numeral( this.total ).format('$0,0.00')
          if (this.pageTotal === this.total) {
          $( api.column( TOTAL_PRICE_COLUMN_INDEX ).footer() ).html(
              `${this.total}`
          );                
          }
          else {
            $( api.column( TOTAL_PRICE_COLUMN_INDEX ).footer() ).html(
                `${this.pageTotal} of ${this.total}`
            );                
          }
        }
    });

    $('table#invoice_charges tbody').on('click', 'tr td a.rate_schedule', async function (e) {
      e.preventDefault();
      const url = e.currentTarget.getAttribute('href')
      const record_id = e.currentTarget.getAttribute('data_rate_schedule_id')
      await this.handle_rate_schedule_click(record_id)
    }.bind(this))
  }

  handle_rate_schedule_click(record_id) {
    if (this.previous_selector_id) {
      document.getElementById(this.previous_selector_id).style.display = 'none';
    }
    let viewer = new RateScheduleViewer(record_id, {previous_selector_id: this.previous_selector_id});
    document.getElementById('rate_schedule_viewer').appendChild(viewer);
    document.getElementById('rate_schedule_viewer').style.display = 'block';
  }
  
  async fetchInvoiceRecordData(){
    const url = `/admin/billing_invoices/${this.billing_invoice_id}/show_data`
    let res = await fetch(url);
    let json = await res.json();
    // console.log(`[InvoiceData] Invoice Record Data: ${JSON.stringify(json)}`)
    return json;
  }
    
  async fetchInvoiceChargesData(){
    const url = `/admin/billing_invoices/${this.billing_invoice_id}/charges`
    let res = await fetch(url);
    let json = await res.json();
    // console.log(`[InvoiceData] Invoice Charges Data: ${JSON.stringify(json)}`)
    return json;
  }

  invoice_with_charges_html() {
    return `
              <div class='data-container table-responsive'>
                <table id='invoice_record_data' class='table table-striped'>
                  <thead>
                    <tr>
                      <th>
                        Id
                      </th>

                      <th>
                        Billing Run Id
                      </th>

                      <th>
                        Invoice Date
                      </th>
                      
                      <th>
                        Billing Group
                      </th>

                      <th>
                        Invoice Number
                      </th>

                      <th>
                        Payment Status
                      </th>

                      <th>
                        Payment URL
                      </th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><span id='invoice_id' class='text-center'></span></td>
                      <td><span id='billing_run_id' class='text-center'></span></td>
                      <td><span id='invoice_date' class='text-center'></span></td>
                      <td><span id='billing_group_name' class='text-center'></span></td>
                      <td>
                        <a
                          id="stripe_invoice_pdf_url"
                          href=""
                          title="Click to download PDF"
                        >
                          <span id='stripe_invoice_number' class='text-center'></span>
                        </a>
                      </td>
                      <td>
                        <i id='stripe_invoice_paid'></i>
                      </td>
                      <td><a 
                        target='_blank'
                        title='Open payment portal in new tab'
                        id='stripe_payment_url' 
                        class='text-center'>
                        Payment Portal</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>    

              <h3>Charges</h3>
              <div class='data-container table-responsive'>
                <table id='invoice_charges' class='table table-striped'>
                  <thead>
                    <tr>
                      <th>
                        Plan
                      </th>

                      <th>
                        Description
                      </th>

                      <th>
                        Billed Group
                      </th>
                      <th>
                        Location Name
                      </th>
          
                      <th>
                        Quantity
                      </th>

                      <th>
                        Tier Low Value
                      </th>

                      <th>
                        Tier High Value
                      </th>

                      <th>
                        Price
                      </th>

                      <th>
                        Total
                      </th>
                                        
                      <th>
                        Period Start Date
                      </th>
              
                      <th>
                        Period End Date
                      </th>
                                  
                    </tr>
                  </thead>
                  <tbody>
                  </tbody>

                  <tfoot>
                      <tr>
                          <th colspan="8" style="text-align:right">Totals:</th>
                          <th colspan="1" id='total_price' style="text-align:right"></th>
                          <th colspan="2" style="text-align:center"></th>
                      </tr>
                  </tfoot>
                </table>
              </div>

              `
  }

  async connectedCallback() {   
    this.billing_invoice_id = this.getAttribute('billing_invoice_id')
    // console.log('[InvoiceData] billing_invoice_id: ' + this.billing_invoice_id)

    this.group_id = this.getAttribute('group_id')
    // console.log('[InvoiceData] group_id: ' + this.group_id)

    this.previous_selector_id = this.getAttribute('previous_selector_id')

    const html = (this.group_id !== null) ? this.group_invoices_html() : this.invoice_with_charges_html()    
    this.innerHTML = 
      `<style>
        
      </style>

      ${html}
    `;

    // pageLoadingFrame("show")
    if (this.group_id) {
      await this.init_invoices_table()
    }
    else if (this.billing_invoice_id) {
      await this.init_record_data_table()
      await this.init_charges_table()
    }

    // pageLoadingFrame("hide")
  }
}

customElements.define("invoice-data", InvoiceData)